export default __webpack_public_path__ + "assets/audios/6a95d3018970d8bfe9063a6fefd724c2.mp3";